import React, { useCallback, useContext, useEffect, useState } from 'react'
import { ProfileModel } from '../../modules/profile/profileModel'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../modules/reducers'
import { isModalVisible } from '../../modules/reducers/modal/selector'
import { modalTypes } from '../../enums/modalTypeEnum'
import fetchFactory from '../../utils/fetchFactory'
import { convertProfile } from '../../modules/profile/profileMapper'
import { hideModal } from '../../modules/reducers/modal/actions'
import PrelevementModal from '../../modules/profile/prelevement/PrelevementModal'
import Dialog from '../dialog/Dialog'
import { AppContext } from '../../containers/context/AppContext'

const SubscriptionPrelevementModal: React.FC = () => {
	const [profile, setProfile] = useState<ProfileModel | null>(null)
	const { setUserInfos } = useContext(AppContext)

	const dispatch = useDispatch()

	const prelevementModalIsOpen = useSelector((state: RootState) => isModalVisible(state, modalTypes.prelevement))

	const getUserDetails = useCallback(() => {
		fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/utilisateur/details`)
			.then((res: any) => {
				if (res && res.length) {
					const convertedProfile = convertProfile(res[0])
					setProfile(convertedProfile)
					setUserInfos(convertedProfile)
				}
			})
			.catch(e => setProfile(null))
	}, [setUserInfos])

	useEffect(() => {
		getUserDetails()
	}, [getUserDetails])

	const closePrelevement = () => {
		dispatch(hideModal(modalTypes.prelevement))
	}
	return (
		profile &&
		<Dialog
			onCloseDialog={closePrelevement}
			open={prelevementModalIsOpen}
		>
			<PrelevementModal
				userDetails={{ email: profile.email, phone: profile.phone }}
				closeDialog={closePrelevement}
			/>
		</Dialog>
	)
}
export default SubscriptionPrelevementModal
